import { render, staticRenderFns } from "./PainelComiteInclusao.vue?vue&type=template&id=65d8fa08"
import script from "./PainelComiteInclusao.vue?vue&type=script&lang=js"
export * from "./PainelComiteInclusao.vue?vue&type=script&lang=js"
import style0 from "./PainelComiteInclusao.vue?vue&type=style&index=0&id=65d8fa08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports